import { Check } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

const FEATURES = [
  "Professional website design",
  "Mobile-friendly layout",
  "Up to 5 core pages",
  "Contact/quote form",
  "Your business branding",
  "Services section",
  "About section",
  "Reviews/testimonials section if customer provides them",
  "Service area information",
  "Basic on-page SEO setup",
  "SSL",
  "Hosting",
  "Domain connection assistance",
  "Ongoing maintenance",
  "Reasonable small content updates",
  "Lead notifications",
];

export const IncludedFeatures = () => {
  return (
    <section
      id="included"
      className="bg-white"
      data-testid="section-included"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
        <SectionHeading
          eyebrow="What's Included"
          title="Everything Your Business Website Needs"
          subtitle="One package with the essentials small businesses actually use."
          testId="heading-included"
        />
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3">
          {FEATURES.map((f) => (
            <li
              key={f}
              className="flex items-start gap-2.5 md:gap-3 rounded-xl border border-goc-border bg-white px-3.5 py-2.5 md:px-4 md:py-3.5 hover:border-goc-primary/50 transition-colors"
              data-testid={`included-item-${f
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")}`}
            >
              <span className="mt-0.5 inline-flex h-5 w-5 md:h-6 md:w-6 shrink-0 items-center justify-center rounded-full bg-goc-primary/10 text-goc-primary">
                <Check className="h-3 w-3 md:h-3.5 md:w-3.5" strokeWidth={3} />
              </span>
              <span className="text-[15px] md:text-sm leading-snug text-goc-text">{f}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default IncludedFeatures;
